<template>
  <div>
    <h5 class="content-block">Riwayat Pendidikan</h5>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          :ref="dataGridRef"
          class="dx-card wide-card"
          id="dataGrid"
          :data-source="dataSource"
          :focused-row-index="0"
          :show-borders="true"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :allow-column-reordering="true"
          @exporting="onExporting"
        >
          <dx-paging :page-size="10" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <dx-filter-row :visible="true" />

          <DxExport :enabled="true" :allow-export-selected-data="true" />
          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />
          <DxToolbar>
            <DxItem name="groupPanel" />
            <DxItem location="after" template="button-template" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <DxButton @click="exportGrid()" text="Export PDF" />
          <template #button-template>
            <DxButton text="Import data" :width="136" @click="importClick" />
          </template>
          <dx-column
            data-field="pegawai.nama"
            caption="Pegawai"
            :allow-sorting="true"
            :fixed="true"
            fixed-position="left"
          />

          <dx-column
            data-field="pendidikan_jenjang_id"
            caption="Jenjang Pendidikan"
            :allow-sorting="true"
          >
            <DxLookup
              :data-source="pendidikanJenjangSource"
              value-expr="id"
              display-expr="nama"
            />
          </dx-column>
          <dx-column
            data-field="institusi"
            caption="Institusi"
            :allow-sorting="true"
          />
          <dx-column
            data-field="fakultas"
            caption="Fakultas"
            :allow-sorting="true"
          />
          <dx-column
            data-field="jurusan"
            caption="Jurusan"
            :allow-sorting="true"
          />
          <dx-column data-field="ipk" caption="IPK" :allow-sorting="true" />
          <dx-column
            data-field="tahun_mulai"
            caption="Tahun Mulai"
            :allow-sorting="true"
          />
          <dx-column
            data-field="tahun_lulus"
            caption="Tahun Lulus"
            :allow-sorting="true"
          />
          <dx-column
            data-field="ijazah_no"
            caption="No. Ijazah"
            :allow-sorting="true"
          />
          <dx-column
            data-field="ijazah_tgl"
            caption="Tgl. Ijazah"
            :allow-sorting="true"
            data-type="date"
            :format="'dd/MM/yyyy'"
          />
          <DxColumn
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-editing="false"
            :allow-adding="false"
            cell-template="fileTemplate"
            caption="Dokumen"
            data-field="file_path"
            data-type="string"
          />

          <template #fileTemplate="{ data }">
            <div class="small-button-container">
              <DxButton
                :visible="setPrintAdaFile(data.text)"
                @click="handleClickDocument(data)"
                icon="download"
              />
            </div>
          </template>

          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="id"
            caption=" "
            :allow-exporting="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
          <template #file-cell-template="{ data }">
            <div v-if="data.value !== null">
              <a :href="serverUrl + data.value">Download File</a>
            </div>

            <!-- <a :href="data.text" v-if="data">AA{{ data.text }}</a> -->
          </template>

          <!-- <template #cabang-cell-template="{ data }">
            {{ getCabang(data.value) }}
          </template> -->
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
/* eslint-disable */
import { BASE_URL } from "@/global-constants";
import _ from "lodash";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  // DxEditing,
  DxColumnFixing,
  // DxSelection,
  DxExport,
  DxButton,
  DxToolbar,
  DxItem,
  DxLookup,
} from "devextreme-vue/data-grid";
import notify from "devextreme/ui/notify";
import DxDropDownButton from "devextreme-vue/drop-down-button";
// eslint-disable-next-line
import router from "@/router";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";

import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import { jsPDF } from "jspdf";
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";

// const cabangStore = new ODataStore({
//   type: "odata",
//   url: "http://127.0.0.1/odata/Cabangs",
//   key: "id",
//   version: 4,
//   beforeSend: function (e) {
//     console.log(e);
//     e.headers = {
//       "odata-version": "4.0",
//     };
//   },
// });

// url: "http://127.0.0.1:8000/odata/LodataMasters?$expand=lodata_details",
const pegawaiStore = new ODataStore({
  type: "odata",

  // url: "http://127.0.0.1/odata/Pegawais?$filter=job_histories/any(s:s/status eq 1)&$expand=job_histories($filter=status eq 1)",
  url: "http://127.0.0.1/odata/PendidikanHistories",
  key: "id",
  version: 4,
  expand: "pegawai",
  // sort: ["nama", { selector: "nama", desc: true }],
  // expand: "lodata_details",
  beforeSend: function (e) {
    e.headers = {
      "odata-version": "4.0",
    };
  },

  onLoaded: () => {
    // Event handling commands go here
  },
});

const pegawaiDataSource = new DataSource({
  store: pegawaiStore,
  // expand: "job_histories",
  // sort: "nama",
  // select: [
  //         'id',
  //         'nama',
  //         'job_histories/cabang_id',

  //       ],
  dataGridRefName: "dataGrid",

  // filter: ["job_histories/any(s:s/status" , '=', "1)"],
  // select: ["id", "nama", "lodata_details.nama"],

  // sort: "nama",
});

// const cabangDataSource = new DataSource({
//   store: cabangStore,
// });

const options = ["Detail", "Transfer", "Resign", "Delete"];

const ds = new DataSource({
  store: new ODataStore({
    // ODataStore is configured here
    url: "http://127.0.0.1/odata/PendidikanHistories",
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  }),
  expand: ["pegawai"],
});
const dataGridRef = "dataGrid";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,

    DxPager,
    DxPaging,
    // DxEditing,
    DxColumnFixing,
    DxButton,
    DxDropDownButton,
    DxExport,
    // DxSelection,
    DxToolbar,
    DxLookup,
    DxItem,
  },
  data() {
    return {
      serverUrl: `${BASE_URL}/`,
      dataGridRef,
      serverUrl: "http://127.0.0.1/",
      ds,
      events: [],
      dataSource: ds,
      cabangSource: new ODataStore({
        url: "http://127.0.0.1/odata/Cabangs",
        key: "id",
      }),
      pendidikanJenjangSource: new ODataStore({
        url: "http://127.0.0.1/odata/PendidikanJenjangs",
        key: "id",
      }),
      bagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/Bagians",
        key: "id",
      }),
      subBagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/SubBagians",
        key: "id",
      }),
      golonganSource: new ODataStore({
        url: "http://127.0.0.1/odata/Golongans",
        key: "id",
      }),
      agamaSource: new ODataStore({
        url: "http://127.0.0.1/odata/Agamas",
        key: "id",
      }),
      options: options,
      router: router,
    };
  },
  computed: {
    dataGrid: function () {
      return this.$refs[dataGridRef].instance;
    },
  },
  methods: {
    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },

    handleClickDocument(e) {
      this.fileUrl = e.data.file_path;
      this.downloadFile();
    },
    downloadFile() {
      if (this.fileUrl !== null) {
        console.log("ADA FILE DOWNLOAD");
        window.open(this.serverUrl + this.fileUrl, "_blank", "location=yes");
      } else {
        console.log("TIDAK ADA");
        notify("File tidak ada", "error");
      }
    },
    getCabang(index) {
      // console.log(index);
      // console.log(cabangStore)
      //  const coba = _.find(this.cabangs, { id: index });
      // return coba.nama;
    },
    dataEx() {
      console.log(this.pegawaiDataSource);
    },
    importClick() {
      this.router.push({
        name: "practice-sheetjs",
        query: { table: "pegawai" },
      });
    },
    logEvent(eventName) {
      this.events.unshift(eventName);
    },
    clearEvents() {
      this.events = [];
    },

    onSaving(e) {
      console.log(e);
    },
    myCommand(e) {
      console.log(e);
      alert("command");
    },
    onItemClick(e) {
      console.log(e.element.id);
      let pegawaiId = e.element.id;
      notify(e.itemData.name || e.itemData, "success", 600);
      this.router.push({
        name: "navigation-menu-edit",
        query: { id: pegawaiId },
      }); //?id=1
      // this.router.push({ name: "tab-treeview", params: { id: pegawaiId } }); //id tak terlihat di url
    },
    exportGrid() {
      const doc = new jsPDF();
      exportDataGridToPdf({
        jsPDFDocument: doc,
        component: this.dataGrid,
      }).then(() => {
        doc.save("Customers.pdf");
      });
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Data Pegawai");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Riwayat Pendidikan Pegawai.xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};

const cabangs = [
  { id: 1, nama: "Pusat" },
  { id: 2, nama: "Gerokgak" },
  { id: 3, nama: "Busungbiu" },
  { id: 4, nama: "Seririt" },
  { id: 5, nama: "Lovina" },
  { id: 6, nama: "Kubutambahan" },
  { id: 7, nama: "Sambirenteng" },
];

// const bagians = [
//   { name: "Litbang", value: "Litbang" },
//   { name: "Produksi", value: "Produksi" },
//   { name: "Distribusi", value: "Distribusi" },
//   { name: "Akuntansi", value: "Akuntansi" },
//   { name: "Keuangan", value: "Keuangan" },
//   { name: "Personalia", value: "Personalia" },
// ];

// const subBagians = [{ name: "TI", value: "TI" }];

// const jabatans = [
//   { name: "Kabag", value: "Kabag" },
//   { name: "Kasubag", value: "Kasubag" },
//   { name: "Staf", value: "Staf" },
//   { name: "Direktur Utama", value: "Direktur Utama" },
// ];

// const golongans = [
//   { name: "A1", value: "A1" },
//   { name: "B1", value: "B1" },
//   { name: "C1", value: "C1" },
// ];

// const statuss = [
//   { name: "Pegawai Tetap", value: "Pegawai Tetap" },
//   { name: "Calon Pegawai", value: "Calon Pegawai" },
//   { name: "Kontrak", value: "Kontrak" },
//   { name: "Training", value: "Training" },
// ];

// const agamas = [
//   { name: "Hindu", value: "Hindu" },
//   { name: "Islam", value: "Islam" },
//   { name: "Buddha", value: "Buddha" },
// ];
</script>

<style>
/* .dx-datagrid-headers {
  background-color: red !important;
}
.dx-datagrid-headers {
  background-color: red !important;
} */
</style>
